import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../../lib/net";
import * as utils from "../../../assets/utils";

import Fr_Input from "../../../lib/ui/fr_input";
import Fr_Cal from "../../../lib/ui/fr_cal";
import Lang from "../../../lib/lang";
import Td_Sel from "../../../lib/ui/td_sel";

import Wnd_Error from "../../../lib/ui/wnd_error";
import Wnd_Ok from "../../../lib/ui/wnd_ok";
import Wnd_Info from "../../../lib/ui/wnd_info";
import Wnd_Confirm from "../../../lib/ui/wnd_confirm";

import Prd_Add from "./mnu_prd_add";
import Prd_Edit from "./mnu_prd_edit";
import Md_Add from "./md_add";
import Md_Edit from "./md_edit";

class Mnu_Edit extends React.Component {
  constructor(props, context) {
    super(props);

      this.store = props.store;
    ///this.pos = props.store.pos;

    this.state = {};
      this.state.mpa = [];
      this.state.mda = [];

    this.state.gnr = "001";
    this.state.ynq = [
                {id: '0', text: 'NEJ'},
                {id: '1', text: 'JA'}
            ];
      this.state.mtval = [
          {id: 'bas', text: 'BAS MENY'},
          {id: 'xtra', text: 'EXTRA MENY'}
      ];

      this.state.tabval = 0;
      this.state.selrow = {};
      this.state.msg = {};
      this.state.wnds = {};
      this.state.zon = {};
      this.state.mdo = {};
      this.state.mno = {};
    if(props.wnds.mno) this.state.mno = props.wnds.mno;
      //alert(JSON.stringify(this.state.mno));
      if(!this.state.mno.zones) this.state.mno.zones = [];
    }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
      //if(!this.props.wnds.tdo) this.task_init();
      this.mnu_mp();
  }

    task_init() {
        var tdo = {};
        tdo.typ = "";
        tdo.id = "";
        tdo.text = "";
        tdo.reg = "";
        tdo.status = "";
        //alert(JSON.stringify(rso));
        this.setState({ tdo: tdo });
        return;
    }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }
    tb_style() {
        var css = {};
        css.height = (window.innerHeight * 0.9) - 275;
        css.overflow = "auto";
        return css;
    }
    th_style(id) {
        var css = {};
        css.cursor = "pointer";
        if(id == this.state.sortid) {
            if(this.state.sortdir) css.color = "#800";
            else css.color = "#080";
        }
        return css;
    }
    row_style(row) {
        var srow = this.state.selrow;

        var css = {};
        if(srow == row) {
            css.background = "#080";
            css.color = "#fff";
        }
        return css;
    }
    tab_head(tabid) {
        var css = {};
        css.background = "#fff";
        css.color = "#000";
        if(this.state.tabval === tabid) {
            css.background = "#080";
            css.color = "#fff";
        }
        return css;
    }
    tab_style(tabid) {
        var css = {};
        css.display = "none";
        if(this.state.tabval === tabid) css.display = "block";
        return css;
    }
    tab_sel(tabid) {
      var self = this;
        this.setState({tabval: tabid}, function() {
            //alert(JSON.stringify(tabid));
            if(tabid == 1) {
                self.syncTb("mnpTable");
            }
            if(tabid == 2) {
                self.syncTb("mdeTable");
            }
            if(tabid == 3) {
                self.syncTb("mdtTable");
            }
            if(tabid == 4) {
                self.syncTb("mdsTable");
            }
            if(tabid == 5) {
                self.syncTb("mddTable");
            }
        });
    }

    wnd_close = () => {
        if(this.props.close) {
            this.props.close(this.props.ctx);
        }
        else this.props.ctx.setState({ wnds: {} });
    };
    mt_change (e) {
        const value = e.target.value;
        var mno = this.state.mno;
        mno.mnutyp = value;
        this.setState({mno: mno});
    }
    anm_change (e) {
        const value = e.target.value;
        var mno = this.state.mno;
        mno.anm = value;
        this.setState({mno: mno});
    }

    val_save(id, val) {
        var mno = this.state.mno;
        mno[id] = val;
        this.setState({ mno: mno });
        return;
    }
    zon_save(id, val) {
        var zon = this.state.zon;
        zon[id] = val;
        this.setState({ zon: zon });
        return;
    }
    sel_row(row) {
        var srow = this.state.selrow;
        if(srow == row) {
            this.setState({selrow: {}});
        }
        else this.setState({selrow: row});
        this.syncTb("mnpTable");
    }
    sel_row_fkn(row, sel) {
        if(sel.fkn == "open") {
        }
    }
    mnu_mp() {
        var self = this;
        var prm = {};
        prm.req = "dsi.dsi_mp.mp_mnu";
        prm.mnuid = this.state.mno.mnuid;

        net.sio_req(prm)
            .then(function(ret){
                //alert(JSON.stringify(ret.rca));

                self.setState({ mpa: ret.rca });
                //self.setState({ rva: ret.rca });
                self.syncTb("mnpTable");
                self.mnu_md("");

            })
            .catch(function(e){
                var txt = JSON.stringify(e);
            });
    }
    mnu_md(typ) {
        var self = this;

        var mnuid = this.state.mno.mnuid;

        var prm = {};
        prm.req = "pos.pos_mnudata.md_list";
        prm.mnuid = mnuid;
        //alert(JSON.stringify(prm));

        net.sio_req(prm)
        .then(function(ret){
            //alert(JSON.stringify(ret.rca));

            self.setState({ mdo: ret.rco });
            if(typ == "E") self.syncTb("mdeTable");
            if(typ == "T") self.syncTb("mdtTable");
            if(typ == "S") self.syncTb("mdsTable");
            if(typ == "D") self.syncTb("mddTable");
        })
        .catch(function(e){
            var txt = JSON.stringify(e);
        });
    }
    syncTb(tb) {
        if (!document.getElementById(tb)) {
            //alert("No tb");
            return;
        }
        var tbel = document.getElementById(tb);
        const thElements = tbel.getElementsByTagName('th'),
            tdElements = tbel.getElementsByTagName('td');
        if(tdElements.length < 1 ) return;
        //alert(JSON.stringify(thElements.length));
        //alert(JSON.stringify(tdElements.length));

        for (let i = 0; i < thElements.length; i++) {
            const widerElement =
                thElements[i].offsetWidth > tdElements[i].offsetWidth ? thElements[i] : tdElements[i],
                width = window.getComputedStyle(widerElement).width;
                thElements[i].style.width = tdElements[i].style.width = width;
        }
    }
    tb_sort(typ) {
        var self = this;
        //var rvs = self.state.rvs;
        var rva = self.state.rva;
        var sortid = this.state.sortid;
        var sortdir = this.state.sortdir;

        if(sortid != typ) sortdir = 0;
        else {
            if(sortdir) sortdir = 0;
            else sortdir = 1;
        }

        if(typ == "ank") {
            if(sortdir) rva.sort((a,b) => (a.gsb00.r0ankdatum < b.gsb00.r0ankdatum) ? 1 : ((b.gsb00.r0ankdatum < a.gsb00.r0ankdatum) ? -1 : 0));
            else rva.sort((a,b) => (a.gsb00.r0ankdatum > b.gsb00.r0ankdatum) ? 1 : ((b.gsb00.r0ankdatum > a.gsb00.r0ankdatum) ? -1 : 0));
        }
        self.setState({ rva: rva, sortid: typ, sortdir: sortdir });
    }
    th_icon(typ) {
        var cls = "";
        var sortid = this.state.sortid;
        var sortdir = this.state.sortdir;
        if(sortid == typ)
        {
            if(sortdir) cls = "fa fa-caret-up";
            else cls = "fa fa-caret-down";
        }
        return cls;
    }
  mnu_save() {
    var self = this;
    var prm = {};
    prm.req = "dsi.dsi_mnu.mnu_upd";
    prm.mno = this.state.mno;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));
        if(ret.ok == "000") {
            self.setState({ msg: {ok: true, text: "Sparad ..."} });
            setTimeout(function(){
                self.setState({msg: {} });
                  if(self.props.wnds.cb) {
                      self.props.wnds.cb(self.props.ctx);
                  }
                  else self.props.ctx.setState({ wnds: {} });
                return;
            }, 1000);
        }
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
  mnu_del() {
    var self = this;
    var prm = {};
      prm.req = "dsi.dsi_mnu.mnu_del";
      prm.mno = this.state.mno;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));
        if(ret.ok == "000") {
            self.setState({ msg: {ok: true, text: "Borttagen"} });
            setTimeout(function(){
                self.setState({msg: {} });
                  if(self.props.wnds.cb) {
                      self.props.wnds.cb(self.props.ctx);
                  }
                  else self.props.ctx.setState({ wnds: {} });
                return;
            }, 1000);
        }
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
    prd_add() {
        var self = this;

        var wnds = {};
        wnds.prdadd = true;
        wnds.mno = this.state.mno;
        wnds.mpa = this.state.mpa;
        wnds.cb = this.cb_prd;
        this.setState({wnds: wnds});
    }
    cb_prd(ctx) {
        ctx.setState({ wnds: {} });
        ctx.mnu_mp();
    }
    prd_edit(row) {
        var self = this;

        var wnds = {};
        wnds.prdedit = true;
        wnds.mpo = row;
        wnds.cb = this.cb_prd;
        this.setState({wnds: wnds});
    }

    md_add(typ) {
        var self = this;

        var wnds = {};
        wnds.mdadd = true;
        wnds.mtyp = typ;
        wnds.mno = this.state.mno;
        wnds.cb = this.cb_md;
        this.setState({wnds: wnds});
    }
    cb_md(ctx) {
        ctx.setState({ wnds: {} });
        ctx.mnu_md("");
    }
    md_edit(row) {
        var self = this;

        var wnds = {};
        wnds.mdedit = true;
        wnds.mno = this.state.mno;
        wnds.mdo = row;
        wnds.cb = this.cb_md;
        this.setState({wnds: wnds});
    }
    show_md(row, typ) {
        var css = {};
        if(row.m0typ != typ) css.display = "none";
        return css;
    }
    get_md(typ) {
        var a = [];
        //if(typ == "E") a = this.state.mdo[typ];
        a = this.state.mdo[typ];
        if(!a) a = [];
        return a;
    }

    pub_plus() {
        var self = this;
        if(false) {
            this.setState({procup: 80});
            return;
        }

        //this.setState({ loading: 1 });
        var msg = { info: true, text: "Publicerar PLU..."};
        self.setState({msg: msg });

        var sid = "S0003200";
        if(this.state.unit == "0001") sid = "S0003201";
        if(this.state.unit == "0002") sid = "S0003202";
        sid = "S0003201";
        //var paa = self.props.store.pos.plus;
        var paa = self.state.mpa;

        var prm = {};
        prm.req = "pos.pos_plu.plus_mupd";
        prm.sid = sid;
        prm.avd = this.state.avd;
        prm.mnunr = this.state.mnunr;
        prm.paa = paa;
        alert(JSON.stringify(prm));
        return;

        net.sid_req(prm)
            .then(function(ret){
                //alert(JSON.stringify(ret.ok));

                var msg = { info: false, ok: true, text: "PLU publicerade..."};
                self.setState({msg: msg });
                setTimeout(function(){
                    self.setState({msg: {} });
                }, 1000);
            })
            .catch(function(e) {
                var txt = JSON.stringify(e);
            });
    }
    zone_add() {
        var mno = this.state.mno;
        var zon = this.state.zon;
        var zone = {};
        zone.zoneid = zon.zoneid.tonum(4);
        zone.ftid = zon.ftid.totid();
        zone.ttid = zon.ttid.totid();
        if(!mno.zones) mno.zones = [];
        mno.zones.push(zone);
        zon.zoneid = "";
        zon.ftid = "";
        zon.ttid = "";
        this.setState({ mno: mno, zon: zon });
    }
    zone_del(row) {
        var mno = this.state.mno;
        if(!mno.zones) mno.zones = [];
        for(var key in mno.zones) {
            var zone = mno.zones[key];
            if(zone == row) mno.zones.splice(key, 1);
        }
        //mno.zones.push(zone);
        this.setState({ mno: mno });
    }

  render() {
    //if(!this.props.show) return "";
    var title = this.props.title;
    if(!title) title = "Resurs";
    //if(props.kro) alert(props.kro.krr00.kid);

	var html =
        <div className="mx_base">
        <div className="mx_backdrop" />
        <div className="mx_dlg mx_90 flex-col" style={ this.dlg_style() } >
        <div className="mx_content flex">

        <div className="mx_h01">
            <div>MENY : { utils.toNum( this.state.mno.mnuid ) }</div>
        </div>
        <div className="divider_orange"></div>

            <div className="flex-row">
                <div className="tab_header flex" style={ this.tab_head(0) } onClick={ () => this.tab_sel(0) }>MENY</div>
                <div className="tab_header flex" style={ this.tab_head(1) } onClick={ () => this.tab_sel(1) }>PRODUKTER</div>
                <div className="tab_header flex" style={ this.tab_head(2) } onClick={ () => this.tab_sel(2) }>EXTRA INGREDIENSER</div>
                <div className="tab_header flex" style={ this.tab_head(3) } onClick={ () => this.tab_sel(3) }>TILLBEHÖR</div>
                <div className="tab_header flex" style={ this.tab_head(4) } onClick={ () => this.tab_sel(4) }>SIDEORDER</div>
                <div className="tab_header flex" style={ this.tab_head(5) } onClick={ () => this.tab_sel(5) }>DRYCK</div>
            </div>
            <div className="divider_green"></div>
            <div hidden={this.state.tabval !== 0}>
            <form className="cdi_f03">
                <div className="flex-row">
                    <div className="form-group flex-row flex">
                        <span className="header">Menytyp</span>
                        <select value={this.state.mno.mnutyp} className="form-control w250" onChange={(e) => this.mt_change(e)}>
                            { this.state.mtval.map((row, key) =>
                                <option key={key} value={row.id}>{row.text}</option>
                            )}
                        </select>
                    </div>
                </div>
                <div className="flex-row">
                    <Fr_Input label="Text" className="text-left w350" text={this.state.mno.text} getValue={(e)=> this.val_save("text", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input label="Meny ID" className="text-left w150" text={this.state.mno.mnuid} getValue={(e)=> this.val_save("mnuid", e) } />
                    <Fr_Input label="Status" className="text-left w350" text={this.state.mno.status} getValue={(e)=> this.val_save("status", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input label="Meny Sort" className="text-left w150" text={this.state.mno.sort} getValue={(e)=> this.val_save("sort", e) } />
                </div>

                <div className="divider_green"></div>
                <div className="flex-col px-5">
                    <div className="flex-row">
                        Zoner
                    </div>
                    <div className="flex-col">
                    { this.state.mno.zones.map((row, key) =>
                            <div className="flex-row" onClick={ () => this.zone_del(row) }>
                            <div className="">{ row.zoneid }</div>
                            <div className="px-1">( { row.ftid } - { row.ttid } )</div>
                            <div className="web-link">TA BORT</div>
                            </div>
                    )}
                    </div>
                    <div className="flex-row">
                        <Fr_Input label="Zone" className="text-left w150" text={this.state.zon.zoneid} getValue={(e)=> this.zon_save("zoneid", e) } />
                        <Fr_Input label="Från" className="text-left w150" text={this.state.zon.ftid} getValue={(e)=> this.zon_save("ftid", e) } />
                        <Fr_Input label="Till" className="text-left w150" text={this.state.zon.ttid} getValue={(e)=> this.zon_save("ttid", e) } />
                        <div className="web-link" onClick={() => this.zone_add() }>LÄGG TILL</div>
                   </div>
                    <div className="flex-row hide">
                        <div className="web-link" onClick={() => this.zone_add() }>LÄGG TILL</div>
                        <div className="flex"></div>
                        <div className="web-link" onClick={() => this.zones() }>UPPDATERA</div>
                   </div>
                </div>

                <div className="divider_green"></div>
                <div className="flex-row">
                    <div className="flex flex-column" style={{padding: "0px 5px"}}>
                        <span className="header">Meny information</span>
                        <textarea className="form-control" maxLength="512" rows="10" value={this.state.mno.anm} onChange={(e) => this.tdata_change(e)}></textarea>
                    </div>
                </div>
            </form>
            </div>
            <div hidden={this.state.tabval !== 1}>
                <div className="flex-row px-3">
                    <div className="web-link" onClick={() => this.prd_add() }>LÄGG TILL</div>
                    <div className="flex"></div>
                    <div className="web-link" onClick={() => this.mnu_mp() }>UPPDATERA</div>
                </div>
                <div className="divider_green"></div>
                <div id="mnpTable" className="flex">
                    <table className="table table-bordered table-hover" style={{marginBottom: "0px"}}>
                        <thead>
                        <tr>
                            <th style={ this.th_style("plu") } onClick={() => this.tb_sort("plu") }><Lang>Plu</Lang> <i className={ this.th_icon("plu") }></i></th>
                            <th style={ this.th_style("text") } onClick={() => this.tb_sort("text") }><Lang>Text</Lang> <i className={ this.th_icon("text") }></i></th>
                            <th style={ this.th_style("prdtyp") } onClick={() => this.tb_sort("prdtyp") }><Lang>Prd typ</Lang> <i className={ this.th_icon("prdtyp") }></i></th>
                            <th style={ this.th_style("sort") } onClick={() => this.tb_sort("sort") }><Lang>Sortering</Lang> <i className={ this.th_icon("sort") }></i></th>
                            <th style={ this.th_style("anm") } onClick={() => this.tb_sort("anm") }><Lang>Beskrivning</Lang> <i className={ this.th_icon("anm") }></i></th>
                            <th></th>
                        </tr>
                        </thead>
                    </table>
                    <div style={ this.tb_style() }>
                        <table className="table table-bordered table-hover">
                            <tbody>
                            { this.state.mpa.map((row, key) =>
                                <tr key={key} style={ this.row_style(row) } onClick={() => this.sel_row(row)} onDoubleClick={ () => this.prd_edit(row) }>
                                    <td>{ row.plu }</td>
                                    <td>{ utils.toLang( row.text ) }</td>
                                    <td className="text-center">{ row.prdtyp }</td>
                                    <td>{ row.sort }</td>
                                    <td>{ row.anm }</td>
                                    <td>
                                        <Td_Sel items={ this.selitems } getValue={(e)=> this.sel_row_fkn(row, e)} />
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div hidden={this.state.tabval !== 2}>
                <div className="flex-row px-3">
                    <div className="web-link" onClick={() => this.md_add("E") }>LÄGG TILL</div>
                    <div className="flex"></div>
                    <div className="web-link" onClick={() => this.mnu_md("E") }>UPPDATERA</div>
                </div>
                <div className="divider_green"></div>
                <div id="mdeTable" className="flex">
                    <table className="table table-bordered table-hover" style={{marginBottom: "0px"}}>
                        <thead>
                        <tr>
                            <th style={ this.th_style("plu") } onClick={() => this.tb_sort("plu") }><Lang>Katnr</Lang> <i className={ this.th_icon("plu") }></i></th>
                            <th style={ this.th_style("text") } onClick={() => this.tb_sort("text") }><Lang>Text</Lang> <i className={ this.th_icon("text") }></i></th>
                            <th style={ this.th_style("pris") } onClick={() => this.tb_sort("pris") }><Lang>Pris</Lang> <i className={ this.th_icon("pris") }></i></th>
                            <th style={ this.th_style("sort") } onClick={() => this.tb_sort("sort") }><Lang>Sortering</Lang> <i className={ this.th_icon("sort") }></i></th>
                            <th style={ this.th_style("anm") } onClick={() => this.tb_sort("anm") }><Lang>Beskrivning</Lang> <i className={ this.th_icon("anm") }></i></th>
                            <th></th>
                        </tr>
                        </thead>
                    </table>
                    <div style={ this.tb_style() }>
                        <table className="table table-bordered table-hover">
                            <tbody>
                            { this.get_md("E").map((row, key) =>
                                <tr key={key} style={ this.row_style(row) } style={ this.show_md(row, "E") } onClick={() => this.sel_row(row)} onDoubleClick={ () => this.md_edit(row) }>
                                    <td>{ row.m0katnr }</td>
                                    <td>{ utils.toLang( row.m0text ) }</td>
                                    <td className="text-center">{ utils.toPris( row.m0pris ) }</td>
                                    <td>{ row.m0sort }</td>
                                    <td>{ row.anm }</td>
                                    <td>
                                        <Td_Sel items={ this.selitems } getValue={(e)=> this.sel_row_fkn(row, e)} />
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div hidden={this.state.tabval !== 3}>
                <div className="flex-row px-3">
                    <div className="web-link" onClick={() => this.md_add("T") }>LÄGG TILL</div>
                    <div className="flex"></div>
                    <div className="web-link" onClick={() => this.mnu_md("T") }>UPPDATERA</div>
                </div>
                <div className="divider_green"></div>
                <div id="mdtTable" className="flex">
                    <table className="table table-bordered table-hover" style={{marginBottom: "0px"}}>
                        <thead>
                        <tr>
                            <th style={ this.th_style("plu") } onClick={() => this.tb_sort("plu") }><Lang>Katnr</Lang> <i className={ this.th_icon("plu") }></i></th>
                            <th style={ this.th_style("text") } onClick={() => this.tb_sort("text") }><Lang>Text</Lang> <i className={ this.th_icon("text") }></i></th>
                            <th style={ this.th_style("pris") } onClick={() => this.tb_sort("pris") }><Lang>Pris</Lang> <i className={ this.th_icon("pris") }></i></th>
                            <th style={ this.th_style("sort") } onClick={() => this.tb_sort("sort") }><Lang>Sortering</Lang> <i className={ this.th_icon("sort") }></i></th>
                            <th style={ this.th_style("anm") } onClick={() => this.tb_sort("anm") }><Lang>Beskrivning</Lang> <i className={ this.th_icon("anm") }></i></th>
                            <th></th>
                        </tr>
                        </thead>
                    </table>
                    <div style={ this.tb_style() }>
                        <table className="table table-bordered table-hover">
                            <tbody>
                            { this.get_md("T").map((row, key) =>
                                <tr key={key} style={ this.row_style(row) } style={ this.show_md(row, "T") } onClick={() => this.sel_row(row)} onDoubleClick={ () => this.md_edit(row) }>
                                    <td>{ row.m0katnr }</td>
                                    <td>{ utils.toLang( row.m0text ) }</td>
                                    <td className="text-center">{ utils.toPris( row.m0pris ) }</td>
                                    <td>{ row.m0sort }</td>
                                    <td>{ row.anm }</td>
                                    <td>
                                        <Td_Sel items={ this.selitems } getValue={(e)=> this.sel_row_fkn(row, e)} />
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div hidden={this.state.tabval !== 4}>
                <div className="flex-row px-3">
                    <div className="web-link" onClick={() => this.md_add("S") }>LÄGG TILL</div>
                    <div className="flex"></div>
                    <div className="web-link" onClick={() => this.mnu_md("S") }>UPPDATERA</div>
                </div>
                <div className="divider_green"></div>
                <div id="mdsTable" className="flex">
                    <table className="table table-bordered table-hover" style={{marginBottom: "0px"}}>
                        <thead>
                        <tr>
                            <th style={ this.th_style("plu") } onClick={() => this.tb_sort("plu") }><Lang>Katnr</Lang> <i className={ this.th_icon("plu") }></i></th>
                            <th style={ this.th_style("text") } onClick={() => this.tb_sort("text") }><Lang>Text</Lang> <i className={ this.th_icon("text") }></i></th>
                            <th style={ this.th_style("pris") } onClick={() => this.tb_sort("pris") }><Lang>Pris</Lang> <i className={ this.th_icon("pris") }></i></th>
                            <th style={ this.th_style("sort") } onClick={() => this.tb_sort("sort") }><Lang>Sortering</Lang> <i className={ this.th_icon("sort") }></i></th>
                            <th style={ this.th_style("anm") } onClick={() => this.tb_sort("anm") }><Lang>Beskrivning</Lang> <i className={ this.th_icon("anm") }></i></th>
                            <th></th>
                        </tr>
                        </thead>
                    </table>
                    <div style={ this.tb_style() }>
                        <table className="table table-bordered table-hover">
                            <tbody>
                            { this.get_md("S").map((row, key) =>
                                <tr key={key} style={ this.row_style(row) } style={ this.show_md(row, "S") } onClick={() => this.sel_row(row)} onDoubleClick={ () => this.md_edit(row) }>
                                    <td>{ row.m0katnr }</td>
                                    <td>{ utils.toLang( row.m0text ) }</td>
                                    <td className="text-center">{ utils.toPris( row.m0pris ) }</td>
                                    <td>{ row.m0sort }</td>
                                    <td>{ row.anm }</td>
                                    <td>
                                        <Td_Sel items={ this.selitems } getValue={(e)=> this.sel_row_fkn(row, e)} />
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div hidden={this.state.tabval !== 5}>
                <div className="flex-row px-3">
                    <div className="web-link" onClick={() => this.md_add("D") }>LÄGG TILL</div>
                    <div className="flex"></div>
                    <div className="web-link" onClick={() => this.mnu_md("D") }>UPPDATERA</div>
                </div>
                <div className="divider_green"></div>
                <div id="mddTable" className="flex">
                    <table className="table table-bordered table-hover" style={{marginBottom: "0px"}}>
                        <thead>
                        <tr>
                            <th style={ this.th_style("plu") } onClick={() => this.tb_sort("plu") }><Lang>Katnr</Lang> <i className={ this.th_icon("plu") }></i></th>
                            <th style={ this.th_style("text") } onClick={() => this.tb_sort("text") }><Lang>Text</Lang> <i className={ this.th_icon("text") }></i></th>
                            <th style={ this.th_style("pris") } onClick={() => this.tb_sort("pris") }><Lang>Pris</Lang> <i className={ this.th_icon("pris") }></i></th>
                            <th style={ this.th_style("sort") } onClick={() => this.tb_sort("sort") }><Lang>Sortering</Lang> <i className={ this.th_icon("sort") }></i></th>
                            <th style={ this.th_style("anm") } onClick={() => this.tb_sort("anm") }><Lang>Beskrivning</Lang> <i className={ this.th_icon("anm") }></i></th>
                            <th></th>
                        </tr>
                        </thead>
                    </table>
                    <div style={ this.tb_style() }>
                        <table className="table table-bordered table-hover">
                            <tbody>
                            { this.get_md("D").map((row, key) =>
                                <tr key={key} style={ this.row_style(row) } style={ this.show_md(row, "D") } onClick={() => this.sel_row(row)} onDoubleClick={ () => this.md_edit(row) }>
                                    <td>{ row.m0katnr }</td>
                                    <td>{ utils.toLang( row.m0text ) }</td>
                                    <td className="text-center">{ utils.toPris( row.m0pris ) }</td>
                                    <td>{ row.m0sort }</td>
                                    <td>{ row.anm }</td>
                                    <td>
                                        <Td_Sel items={ this.selitems } getValue={(e)=> this.sel_row_fkn(row, e)} />
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </div>
        <div className="mx_foot flex-row flex-space-between">
            <button className="btn btn-hw-red w250 ripple" onClick={() => this.wnd_close() } >
                STÄNG
            </button>
            <button className="btn btn-hw-red w250 ripple" onClick={() => this.mnu_del() } >
                TA BORT
            </button>
            <div className="flex-row">
            <button className="btn btn-hw-red w250 ripple" onClick={() => this.mnu_save() } >
                SPARA
            </button>
            </div>
        </div>
      </div>

        { this.state.wnds.prdadd ? <Prd_Add wnds={this.state.wnds} store={this.store} ctx={this} /> : null}
        { this.state.wnds.prdedit ? <Prd_Edit wnds={this.state.wnds} store={this.store} ctx={this} /> : null}
        { this.state.wnds.mdadd ? <Md_Add wnds={this.state.wnds} store={this.store} ctx={this} /> : null}
        { this.state.wnds.mdedit ? <Md_Edit wnds={this.state.wnds} store={this.store} ctx={this} /> : null}

        <Wnd_Error msg={this.state.msg} ctx={this} />
        <Wnd_Ok msg={this.state.msg} ctx={this} />
        <Wnd_Info msg={this.state.msg} ctx={this} />
        <Wnd_Confirm msg={this.state.msg} ctx={this} />
      </div>
	;
	return html;
  };
}

export default Mnu_Edit;